import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./pincity.css";
import logoimage from './assets/ajlogo2026.png';
mapboxgl.accessToken =
  "pk.eyJ1IjoiYWpqZXJ1c2FsZW0iLCJhIjoiY2l4b2t3N2lyMDAxMzJxcHMwZ3IzOWN1OSJ9.cxZW0ZgGPFDZpc_-JtRBxg";
// Cities list
const cities = [{"name":"Where is the Pink Mosque, or Nasir al-Mulk?","lat":29.608582,"lon":52.54852,"blurb":"Located in Shiraz, the mosque was built from 1876 to 1888 under the Qajar dynasty and is famed for its intricate muqarnas vaults and colourful tiles, notably its vivid rose‑pink ceiling tiles.","Category":"Religion"},{"name":"Where is the capital, Tehran?","lat":35.712895,"lon":51.368998,"blurb":"With 9.6 million inhabitants, Tehran has been Iran's capital since 1795 and is its largest city. It is located beneath the Alborz Mountains, and its history dates back more than 6,000 years.","Category":"Geographical"},{"name":"Where is the Strait of Hormuz?","lat":26.687095,"lon":56.437432,"blurb":"Located between Iran and Oman, connecting the Gulf to the Arabian Sea, the narrow waterway is the sole maritime exit for several Gulf exporters, and in peacetime, 20 percent of the world’s oil and gas supplies pass through it.","Category":"Geographical"},{"name":"Where is the country's highest mountain?","lat":35.954703,"lon":52.109925,"blurb":"Located about 60-70km (37-43 miles) northeast of Tehran, Mount Damavand with an altitude of 5,610 metres (18,405ft) is a dormant volcano and the highest peak in the Middle East.","Category":"Geographical"},{"name":"Where are the ruins of Persepolis, the ceremonial capital of the Persian Empire?","lat":29.9360017,"lon":52.8891612,"blurb":"The UNESCO World Heritage Site is 60km (37 miles) northeast of Shiraz. It was the ceremonial capital of the Achaemenid Empire (550-330 BC).","Category":"Historical"},{"name":"Where is Imam Reza Shrine, the largest mosque complex in Iran?","lat":36.287777,"lon":59.615492,"blurb":"Located in Mashhad in northeastern Iran and spanning 60 hectares (148 acres), the ornately decorated complex houses the tomb of Imam Reza, the eighth Shia imam.","Category":"Religion"},{"name":"Where is Hormuz Island, known for its red beaches, located?","lat":27.066112,"lon":56.46105,"blurb":"The island is in the Strait of Hormuz, less than 10km (6 miles) southeast of the port city of Bandar Abbas on Iran's mainland. Its striking red landscapes, caused by high concentrations of iron oxide in the soil, attracts many tourists.","Category":"Geographical"},{"name":"Where is Vank Cathedral, the most famous Armenian church in Iran?","lat":32.634963,"lon":51.655703,"blurb":"Located in the New Jolfa district of Isfahan, the church, built between 1606 and 1655, blends Islamic structural design with Armenian Christian artistry.","Category":"Religion"},{"name":"Where is the Monastery of St Thaddeus, home to one of the earliest Christian churches?","lat":39.092304,"lon":44.544295,"blurb":"Known as Qara Kelisa, or the Black Church, the monastery, which is believed to have been founded by St Thaddeus in 66 AD, is located in the mountains of northwest Iran and is a UNESCO World Heritage Site.","Category":"Religion"},{"name":"Where is the Tabriz Grand Bazaar, famous for its vibrant carpet trade, located?","lat":38.080801,"lon":46.292288,"blurb":"Located in the centre of Tabriz, the UNESCO World Heritage Site is the largest covered bazaar in the world and is situated along the historic Silk Road, which contributed to its centuries-old reputation as a commercial hub.","Category":"Historical"},{"name":"Where is the site of the first university in the world, according to UNESCO?","lat":32.288939,"lon":48.515601,"blurb":"The Academy of Gundeshapur, located in Khuzestan, is recognised by UNESCO as the oldest known university. Its origins date back more than 1,750 years, and it is now an archaeological site.","Category":"Education"},{"name":"Where is Kharg Island?","lat":29.24442,"lon":50.310162,"blurb":"Iran’s most important oil export terminal is on Kharg Island, which lies about 55km (34 miles) northwest of the port city of Bushehr and handles about 90 per cent of Iran's crude exports.","Category":"Geographical"},{"name":"Where is the Bushehr Nuclear Power Plant?","lat":28.82996726,"lon":50.8859682,"blurb":"Bushehr, located along the Gulf coast, is one of Iran's most important industrial and military centres and is home to the country’s only operational nuclear power plant.","Category":"Geographical"},{"name":"Where is the Fordow Uranium Enrichment Plant?","lat":34.884593,"lon":50.998298,"blurb":"Located near the city of Qom in central Iran, the site is built deep inside a mountain and was the target of US bunker-buster air strikes in June.","Category":"Geographical"},{"name":"Where is the tomb of the poet Hafez, best known for his ghazals?","lat":29.625756,"lon":52.558408,"blurb":"Hafez, the celebrated 14th-century Persian poet, is buried in his birthplace of Shiraz. His primary work, the Divan-e-Hafez, is a collection of lyrical poems that has profoundly influenced Persian culture and global literature.","Category":"Culture"},{"name":"Which desert is considered to be the world's hottest place?","lat":30.597638,"lon":59.070654,"blurb":"The Lut Desert in southeastern Iran with its dark volcanic rocks that trap heat recorded a land‑surface temperature of 80.8C (177.4F) in 2018.","Category":"Geographical"},{"name":"Where is Qom, the global centre for Shia scholarship?","lat":34.641844,"lon":50.878816,"blurb":"Located about 140km (87 miles) south of Tehran, the holy city is known for its golden-domed Fatima Masumeh Shrine and served as the spiritual and ideological birthplace of the 1979 Iranian Revolution.","Category":"Historical"},{"name":"Where is the small coastal city of Minab?","lat":27.14035707,"lon":57.06593091,"blurb":"Minab is located in Hormozgan Province. On February 28 during the opening hours of the US-Israel war on Iran, a missile, likely a US Tomahawk, struck a girls school in the southern Iranian city, killing more than 170 people, most of them schoolgirls.","Category":"Geographical"},{"name":"Where is the Naqsh-e Jahan Square?","lat":32.657646,"lon":51.677478,"blurb":"Located in the centre of Isfahan, the 17th-century UNESCO World Heritage Site is the second largest square in the world and features the turquoise‑domed Shah Mosque.","Category":"Historical"},{"name":"Where is the Shatt al-Arab (Arvand Rud) waterway?","lat":30.460392,"lon":48.023408,"blurb":"The 200km (120-mile) river at the heart of the 1980-1988 Iran-Iraq War starts at the confluence of the Tigris and Euphrates rivers and flows into the Gulf. Its southern end flows along the Iran-Iraq border, and it is a crucial waterway for global petroleum shipments.","Category":"Historical"},{"name":"Where is the main processing hub for the South Pars gasfield?","lat":27.472855,"lon":52.611279,"blurb":"Iran's main onshore processing hub for South Pars is located in Assaluyeh. The South Pars field is Iran's portion of the world's largest gas reservoir, shared with Qatar (the North Field). Together they hold about 20 percent of global reserves.","Category":"Infrastructure"}];


// Shuffle helper
function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

// Haversine function
function haversine(lat1, lon1, lat2, lon2) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // Earth radius in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export default function PinTheCity() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef([]);

  const [shuffledCities, setShuffledCities] = useState(() => {
    // Select a random 10 cities
    return shuffleArray(cities).slice(0, 10);
  });


  const [cityIndex, setCityIndex] = useState(0);
  const [guess, setGuess] = useState(null);
  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [showFinalScoreButton, setShowFinalScoreButton] = useState(false);

  const [closestCity, setClosestCity] = useState(null);
  const [minDistance, setMinDistance] = useState(null);

  const city = shuffledCities[cityIndex];
  const correct = { lat: city.lat, lon: city.lon };

  // Calculate progress percentage
  const progress = (totalScore/100)*100;


  // Function to determine zoom level based on screen size
function getZoomLevel() {
    const width = window.innerWidth; // Get the width of the window
    if (width <= 480) return 3.7; // Mobile devices
    if (width > 480 && width <= 768) return 4.4; // Tablets
    return 5; // Desktops
}

const iranBounds = [
    [25.462892, 12.315383],  // Southwest: Near the border with Iraq/Turkey & Persian Gulf
    [85.570590, 53.648750] // Northeast: Near the border with Turkmenistan/Afghanistan
];
  
  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/ajjerusalem/cmnoed0f2004801qtegzxd9rn",
        // style:"mapbox://styles/ajjerusalem/clqwcrr61010201qud2ln7vck",
        center: [53.595833,32.068587],
        zoom: getZoomLevel(), // Set zoom level based on screen size
        minZoom: 3.2,
        maxZoom: 6.5,
        interactive: true,
        maxBounds:iranBounds
      });

      mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

      
      mapRef.current.on("click", (e) => {
        if (!revealed) {
          const { lng, lat } = e.lngLat;
          let closest = null;
          let minDist = Infinity;

          cities.forEach((city) => {
            const distance = haversine(lat, lng, city.lat, city.lon);
            if (distance < minDist) {
              minDist = distance;
              closest = city;
            }
          });

          setClosestCity(closest);
          setMinDistance(minDist);
          setGuess({ lat, lon: lng });
        }
      });

      // mapRef.current.on("load", () => {
      //   mapRef.current.addSource("my-image", {
      //     type: "image",
      //     url: process.env.PUBLIC_URL + "/mapo.png",
      //     coordinates: [
      //       [34.2, 33.3],
      //       [35.7, 33.3],
      //       [35.7, 29.477],
      //       [34.2, 29.477],
      //     ],
      //   });

      //   mapRef.current.addLayer({
      //     id: "image-layer",
      //     type: "raster",
      //     source: "my-image",
      //     paint: { "raster-opacity": 1 },
      //   });
      // });
      mapRef.current.getCanvas().style.cursor = 'default';

      mapRef.current.on('mouseleave', () => {
        mapRef.current.getCanvas().style.cursor = 'default'; // Reset to normal cursor
      });
    }
  }, [revealed]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    markerRefs.current.forEach((marker) => marker.remove());
    markerRefs.current = [];

    if (guess) {
      const guessMarker = new mapboxgl.Marker({ color: "red" })
        .setLngLat([guess.lon, guess.lat])
        .addTo(map);
      markerRefs.current.push(guessMarker);
    }

    if (revealed) {
      const correctMarker = new mapboxgl.Marker({ color: "green" })
        .setLngLat([correct.lon, correct.lat])
        .addTo(map);
      markerRefs.current.push(correctMarker);
    }
  }, [guess, revealed]);

  const revealAnswer = () => {
    if (!guess) return;
    const distance = haversine(guess.lat, guess.lon, correct.lat, correct.lon);
    let roundScore = 0;
    if (distance < 100) roundScore = 10;
    else if (distance < 200) roundScore = 9;
    else if (distance < 300) roundScore = 8;
    else if (distance < 400) roundScore = 7;
    else if (distance < 500) roundScore = 6;
    else if (distance < 600) roundScore = 5;
    else if (distance < 700) roundScore = 4;
    else if (distance < 800) roundScore = 3;
    else if (distance < 900) roundScore = 2;
    else if (distance < 1000) roundScore = 1;
    else roundScore = 0;

    setTotalScore((prev) => prev + roundScore);
    setScore(roundScore);
    setRevealed(true);
  
    if (cityIndex === shuffledCities.length - 1) {
      setShowFinalScoreButton(true); // Prepare to show final score
    }
  };

  const nextRound = () => {
    const nextIndex = cityIndex + 1;

    if (nextIndex >= shuffledCities.length) {
      setGameOver(true);
    } else {
      setCityIndex(nextIndex);
      setGuess(null);
      setRevealed(false);
    }
  };

  const restartGame = () => {
    setShuffledCities(shuffleArray(cities).slice(0, 10));  // Limit to 10 cities again
    setGameOver(false);
    setCityIndex(0);
    setTotalScore(0);
    setScore(0);
    setGuess(null);
    setRevealed(false);
  };


  const tweetText = `How well do you know Iran? I scored ${totalScore}/100. @AJEnglish @AJLabs - play here: https://aljazeera.com/iranquiz`;
  const whatsText= `How well do you know Iran? I scored ${totalScore}/100. @AJEnglish @AJLabs — play here: https://aljazeera.com/iranquiz`;
  const tweeturl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
  const whatsurl = `whatsapp://send?text=${encodeURIComponent(whatsText)}`;

  return (
    <div className=" relative w-full h-screen flex flex-col items-center p-4">



<div className="centerbarx flex flex-col items-center">
<div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
  {

    <a href="https://aljazeera.com" target="_blank" rel="noopener noreferrer">
      <img
        src={logoimage}
        alt="Al Jazeera"
        style={{ width: "94px", height:"auto" }}
      />
    </a>
    
  }
  </div>
</div> 

{/* Progress Bar + Counter */}
<div className="rightbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Score: {totalScore}/100
  </div>

  {/* Progress Bar */}
  {/* <div className="rightbar w-3 bg-gray-300 rounded-lg overflow-hidden">
    <div
      className="bg-blue-500 w-full transition-all duration-300"
      style={{ height: `${progress}%` }}
    ></div>
  </div> */}
</div>



<div className="leftbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Question: {cityIndex+1}/{shuffledCities.length}
  </div>
</div>

      {/* Main Content */}
      <p className="text-center whereis font-bold mb-2">
      </p>
      <p className="text-center cityguess">{city.name}</p>
      <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>

      <div
        ref={mapContainer}
        style={{ height: "80vh", width: "100%" }}
        className="mb-4"
      />
      {/* Move the submit button right under the city name */}
      {!revealed && (
          
        <div className="submitbutton text-center mb-4">
               <div> <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>
          <button
            className="buttonguess mt-2 px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
            onClick={revealAnswer}
            disabled={!guess}
          >
            Submit guess
          </button>
        </div>
        </div>
      )}


      {revealed && (
        <div className="popupbox inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="popupin bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
          {!gameOver ? (
            <div><p className="text-lg strong mb-2">
              Your guess is{" "}
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon)
                ).toLocaleString()} km
              (
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon) / 1.61
                ).toLocaleString()} 
              {" "} miles away)
        {/* from {city.name}  */}
        {/* {closestCity && closestCity.name !== city.name && minDistance !== null && (
                <span className="mt-4 text-sm text-gray-700">, but only {Math.round(minDistance)}km from {closestCity.name}</span>
            )} */}
      </p>
      <p className="mb-1 score-text">You scored {score} points!</p>
          
          <p className="blurbtext">{city.blurb}</p>
          </div>
                ) : (<div></div>)}

            {gameOver ? (
              <div>
                <h2 className="text-xl font-semibold mb-2">Game Over!</h2>
                <p className="mb-4 totalscore">Your total score is: {totalScore}/100</p>

                <p>SHARE YOUR SCORE</p>
                <section className="combined-share__links text-center">
            
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Faljazeera.com%2Firanquiz%2F">
                            <svg className="icon icon--facebook icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>facebook</title><path className="icon-main-color" d="M10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785157 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042967,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925782,12.890625 L11.5625,12.890625 L11.5625,19.8785157 C16.3431445,19.1283203 20,14.9912891 20,10 C20,4.47714844 15.5228516,0 10,0 Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter" href={tweeturl}>
                            <svg className="icon icon--twitter icon--social icon--24 " viewBox="0 0 26 24" version="1.1" aria-hidden="true"><title>twitter</title><path className="icon-main-color" fill-rule="evenodd" d="m.063 0 10.039 13.237L0 24h2.273l8.845-9.423L18.263 24H26L15.397 10.018 24.799 0h-2.273l-8.145 8.678L7.801 0H.062Zm3.344 1.652H6.96l15.695 20.696h-3.554L3.407 1.652Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Whatsapp" href={whatsurl}>
                            <svg className="icon icon--whatsapp icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>whatsapp</title><path class="icon-main-color" d="M19 9.74a9.54 9.54 0 0 1-9.33 9.74 9 9 0 0 1-4.51-1.21L0 20l1.68-5.23a10 10 0 0 1-1.33-5A9.53 9.53 0 0 1 9.62 0 9.54 9.54 0 0 1 19 9.74zM14.33 12c-.05-.1-.21-.16-.44-.28s-1.35-.7-1.56-.78-.36-.12-.51.12a11.45 11.45 0 0 1-.73.94c-.13.16-.26.18-.49.06a6.28 6.28 0 0 1-1.84-1.19 7 7 0 0 1-1.27-1.66.35.35 0 0 1 .1-.49c.1-.11.23-.28.34-.42a1.6 1.6 0 0 0 .23-.4.42.42 0 0 0 0-.41c-.06-.12-.51-1.3-.7-1.78s-.39-.4-.52-.4H6.5a.83.83 0 0 0-.61.3 2.74 2.74 0 0 0-.8 2A4.63 4.63 0 0 0 6 10.05a9.54 9.54 0 0 0 3.9 3.61c2.33 1 2.33.64 2.75.6a2.33 2.33 0 0 0 1.54-1.14 2 2 0 0 0 .14-1.12z"></path></svg>
                          </a>

                        </section>
                <button
                  className="buttonguess px-4 py-2 bg-blue-600 text-white rounded"
                  onClick={restartGame}
                >
                  PLAY AGAIN
                </button>
              </div>
            ) : (
              <button
                className="buttonguess padit px-4 py-2 bg-green-600 text-white rounded"
                onClick={nextRound}
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
